var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"list-group-item list-group-item-action",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.setMe(_vm.account._id)}}},[_vm._v("\n  "+_vm._s(_vm.account.name)+"\n  ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6490363f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyAccount/MyAccountItem.vue
// module id = null
// module chunks = 